module.exports = __webpack_public_path__ + "img/uploadPictures.23a25e4d.png";